export const RecordPlansSetReviewResultConfigFragment = gql`
  fragment RecordPlansSetReviewResultConfigFragment on RecordPlansSetReviewResult {
    id
    name
    isPassing
    isDefault
    createdByUser {
      ...UserDataFragment
    }
    createdAt
    recordType {
      id
      displayName
    }
  }
`
